import React from 'react'
import { useDispatch } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import dataStorageService from '../services/DataStorageService';
import { loginReducer } from '../../ReduxStore/Reducers/loginReducer';

let dataService = dataStorageService();

export const AuthGuard = ({children}) => {
    if(!dataService.getLocalStorageData("accessToken")) {
        return <Navigate to="/login" />
    }

    return children ?? <Outlet />;

}
